import { Monitor, Moon, Sliders, Smartphone, Sun, Tablet } from "lucide-react";

export const CUSTOMIZATION_PANEL = {
  WIDTH: "400px",
  TOP_OFFSET: "56px",
  PADDING: "1.5rem",
  Z_INDEX: 100,
  /** Mantine `Transition` duration in ms */
  ANIMATION_DURATION: 200,
  ANIMATION_TIMING_FUNCTION: "cubic-bezier(0.16, 1, 0.3, 1)",
} as const;

export const WIDGET_WIDTH = {
  MIN: 375,
  MAX: 1366,
  MOBILE: 500,
  TABLET: 768,
  DESKTOP: 1024,
  DEFAULT: 500,
} as const;

export const WIDGET_HEIGHT = {
  MIN: 480,
  MAX: 1200,
  MOBILE: 750,
  TABLET: 750,
  DESKTOP: 768,
  DEFAULT: 750,
} as const;

export const getWalletModeOptions = () =>
  [
    { value: "internal" as const, label: "Internal", description: "Widget handles wallet events" },
    {
      value: "external" as const,
      label: "External",
      description: "Host application handles wallet events",
    },
  ] as const;

export const getThemeOptions = () =>
  [
    { value: "light" as const, label: "Light", icon: Sun },
    { value: "dark" as const, label: "Dark", icon: Moon },
  ] as const;

export const SIZE_PRESETS = [
  {
    value: "mobile" as const,
    label: "Mobile",
    icon: Smartphone,
    width: WIDGET_WIDTH.MOBILE,
    height: WIDGET_HEIGHT.MOBILE,
  },
  {
    value: "tablet" as const,
    label: "Tablet",
    icon: Tablet,
    width: WIDGET_WIDTH.TABLET,
    height: WIDGET_HEIGHT.TABLET,
  },
  {
    value: "desktop" as const,
    label: "Desktop",
    icon: Monitor,
    width: WIDGET_WIDTH.DESKTOP,
    height: WIDGET_HEIGHT.DESKTOP,
  },
  { value: "custom" as const, label: "Custom", icon: Sliders, width: null, height: null },
] as const;
